import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule} from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatRadioModule } from "@angular/material/radio";
import { MatToolbarModule } from "@angular/material/toolbar";

import { environment } from './../environments/environment';
import { BrowserModule} from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DeviceDetectorService } from 'ngx-device-detector';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { FormsModule } from '@angular/forms';

import { AccueilModule } from './modules/accueil/accueil.module';
import localeFr from '@angular/common/locales/fr-CA';
import { registerLocaleData } from '@angular/common';
import { ConditionsUtilisationComponent } from './modules/legal/pages/conditions-utilisation/conditions-utilisation.component';
import { PolitiqueViePriveeComponent } from './modules/legal/pages/politique-vie-privee/politique-vie-privee.component';
import { NouvellesComponent } from './modules/apropos/pages/nouvelles/nouvelles.component';
import { NouvellesDetailComponent } from './modules/apropos/pages/nouvelles-detail/nouvelles-detail.component';
import { EntrepriseComponent } from './modules/apropos/pages/entreprise/entreprise.component';
import { NotreEquipeComponent } from './modules/apropos/pages/notre-equipe/notre-equipe.component';
import { NosClientsComponent } from './modules/apropos/pages/nos-clients/nos-clients.component';
import { NosPartenairesComponent } from './modules/apropos/pages/nos-partenaires/nos-partenaires.component';
import { OffresEmploiComponent } from './modules/apropos/pages/offres-emploi/offres-emploi.component';
import { OffresEmploiDetailComponent } from './modules/apropos/pages/offres-emploi-detail/offres-emploi-detail.component';
import { SolutionsComponent } from './modules/solutions/solutions.component';
import { FGPComponent } from './modules/solutions/pages/fgp/fgp.component';
import { PP2Component } from './modules/solutions/pages/pp2/pp2.component';
import { PPMComponent } from './modules/solutions/pages/ppm/ppm.component';
import { FGFComponent } from './modules/solutions/pages/fgf/fgf.component';
import { FGBComponent } from './modules/solutions/pages/fgb/fgb.component';
import { FGIComponent } from './modules/solutions/pages/fgi/fgi.component';
import { SDGComponent } from './modules/solutions/pages/sdg/sdg.component';
import { CAFEComponent } from './modules/solutions/pages/cafe/cafe.component';
import { EDTComponent } from './modules/solutions/pages/edt/edt.component';
import { AccueilComponent } from './modules/accueil/pages/accueil/accueil.component';
import { TemoignagesComponent } from './modules/accueil/components/temoignages/temoignages.component';
import { NewsSlideComponent } from './modules/accueil/components/news-slide/news-slide.component';
import { InscriptionComponent } from './modules/apropos/pages/inscription/inscription.component';
import { SimpleDialogComponent } from './simple-dialog/simple-dialog.component';
import { MessageService } from './shared/message.service';

registerLocaleData(localeFr);

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) : TranslateHttpLoader {

  if(environment.production)
    return new TranslateHttpLoader(http, '/PluriWWW/assets/locales/', '.json'); // Version site web
  else
    return new TranslateHttpLoader(http, './assets/locales/', '.json');  // Version ng serve
}


@NgModule({ declarations: [
        AppComponent, ConditionsUtilisationComponent, PolitiqueViePriveeComponent,
        NouvellesComponent, NouvellesDetailComponent, EntrepriseComponent,
        NotreEquipeComponent, NosClientsComponent, NosPartenairesComponent,
        OffresEmploiComponent, OffresEmploiDetailComponent, SolutionsComponent,
        FGPComponent, PP2Component, PPMComponent, FGFComponent, FGBComponent,
        FGIComponent, SDGComponent, CAFEComponent, EDTComponent, AccueilComponent,
        TemoignagesComponent, NewsSlideComponent, InscriptionComponent, SimpleDialogComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        SharedModule,
        CoreModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatDialogModule,
        MatRadioModule,
        MatToolbarModule,
        AppRoutingModule,
        AccueilModule], providers: [DeviceDetectorService, { provide: LOCALE_ID, useValue: 'fr' }, { provide: MAT_DIALOG_DATA, useValue: {} }, MessageService, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }


